import { Deserializable } from '../../protocols/deserializable';
import { LifeStatusIdEnum } from '../../enum/shared/life-status-id.enum';
import { PaymentSuspensionStateEnum } from '../../../features/payment-suspension/enums/payment-suspension-state.enum';

export class MemberPaymentSuspension implements Deserializable {
  public memberId!: number;
  public suspendPayments: boolean = false;
  public suspendPaymentsChangedById: number | null = null;
  public suspendPaymentsChangedByName: string | null = null;
  public suspendPaymentsChangedDate: string | null = null;
  public lifeStatusHoldsPayments: boolean = false;
  public lifeStatusId!: LifeStatusIdEnum;
  public lifeStatusEffectiveDate: string | null = null;

  // Not From API
  public isSuspended: boolean = false;
  public state: PaymentSuspensionStateEnum = PaymentSuspensionStateEnum.NotSuspended;
  public suspendedOnDate: string | null = null;

  public onDeserialize(): void {
    this.isSuspended = this.suspendPayments || this.lifeStatusHoldsPayments;
    this.state = paymentSuspensionState(this.suspendPayments, this.lifeStatusHoldsPayments);
    this.suspendedOnDate = this.suspendPayments ? this.suspendPaymentsChangedDate : this.lifeStatusEffectiveDate;
  }
}

function paymentSuspensionState(
  suspendPayments: boolean,
  lifeStatusHoldsPayments: boolean
): PaymentSuspensionStateEnum {
  if (suspendPayments && lifeStatusHoldsPayments) return PaymentSuspensionStateEnum.StaffThenLifeStatus;
  if (suspendPayments) return PaymentSuspensionStateEnum.Staff;
  if (lifeStatusHoldsPayments) return PaymentSuspensionStateEnum.LifeStatus;
  return PaymentSuspensionStateEnum.NotSuspended;
}
